import styled from 'styled-components';
import DownloadButton from './DownloadButton';
import { useSelector } from 'react-redux';
import ZoomContainer from './ZoomContainer';
import CalculateDistanceButton from '../calculate-distance/CalculateDistanceButton';
import ShareButton from './ShareButton';
import { MapMode, ResultsType } from '../../types';

const Actions = () => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const resultsType = useSelector((state: any) => state.map.resultsType);
  const sahelMode = useSelector((state: any) => state.map.sahelMode);
  const selectedCompound = useSelector(
    (state: any) => state.map.selectedCompound
  );
  const drawerOpen = useSelector((state: any) => state.map.drawerOpen);
  const mapMode = useSelector((state: any) => state.map.mapMode);

  return (
    <Container drawerOpen={drawerOpen} mapMode={mapMode}>
      {!isMobile && <ZoomContainer />}

      {sahelMode && <DownloadButton />}
      {isMobile && <ShareButton />}
      {!selectedCompound &&
        sahelMode &&
        resultsType == ResultsType.COMPOUNDS && <CalculateDistanceButton />}
    </Container>
  );
};

const Container = styled.div<{ mapMode: MapMode; drawerOpen: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: end;
  justify-content: space-between;
  gap: 10px;
  position: absolute;
  bottom: 38px;
  z-index: 2;
  inset-inline-end: ${props =>
    props.drawerOpen
      ? props.mapMode === MapMode.SEARCH
        ? '374px'
        : '466px'
      : '24px'};

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    top: 130px;
    justify-content: start;
    inset-inline-end: 16px;
  }
`;

export default Actions;
